import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import classes from './MainTitle.css';

class MainTitle extends React.Component{

    render(){

        return (
            <div className={classes.MainTitle}>
                <Row>
                    <Col>
                        <span className={classes.TitleTextNormal}>Book </span>
                        <span className={classes.TitleTextMIY}>MeeY</span>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <div className={classes.TitleTextSubText}>book a call with friends</div>
                    </Col>
                </Row>
            </div>
                        
        );
    }
}

export default MainTitle;


// WEBPACK FOOTER //
// ./src/components/MainTitle/MainTitle.js